<template>
  <div :class="selected_report?.story_board || print_mode ? 'px-print' : 'container'">
    <div class="mb-5">
      <div class="skeleton-text skeleton-title mb-3" style="width: 200px; height: 24px"></div>

      <div v-for="i in 3" :key="'universal-' + i" class="mb-5">
        <div class="skeleton-text mb-3" style="width: 300px; height: 28px"></div>

        <b-row class="mb-3">
          <b-col cols="3">
            <div class="skeleton-text" style="width: 100px; height: 20px"></div>
          </b-col>
          <b-col cols="3">
            <div class="skeleton-text" style="width: 100px; height: 20px"></div>
          </b-col>
          <b-col cols="6">
            <div class="skeleton-text ml-auto" style="width: 200px; height: 20px"></div>
          </b-col>
        </b-row>

        <div v-for="j in 2" :key="'subtopic-' + j" class="mb-4">
          <div class="skeleton-text mb-3" style="width: 350px; height: 24px"></div>

          <div v-for="k in 3" :key="'disclosure-' + k" class="d-flex border-bottom py-3">
            <div class="col-3">
              <div class="skeleton-text mb-2" style="width: 80px; height: 18px"></div>
              <div class="skeleton-text" style="width: 150px; height: 16px"></div>
            </div>
            <div class="col-9">
              <div class="skeleton-text mb-2" style="width: 100%; height: 16px"></div>
              <div class="skeleton-text mb-2" style="width: 90%; height: 16px"></div>
              <div class="skeleton-text" style="width: 70%; height: 16px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GRITableSkeleton',
  props: {
    print_mode: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters('report_list', ['selected_report'])
  }
};
</script>

<style scoped>
.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s ease-in-out infinite;
  border-radius: 4px;
}

.skeleton-title {
  border-radius: 6px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
